import { initAjaxLoadItemsTrigger } from 'allink-core-static/js/modules/ajax-load-items';
import { initMasonry } from 'allink-core-static/js/modules/masonry';

$(function(){

    var options = {
        ajax_load_transition_duration: 100,
    };

    // init modules
    initAjaxLoadItemsTrigger(options);
    initMasonry(options);

    // re-init when softpage has been opened
    $(window).on('softpage:opened',function(){
        initAjaxLoadItemsTrigger(options);
        initMasonry(options);
    });

    // project specifc
    initSpecialAjaxFilter();
    initAjaxLoadItemsTriggerSpecial();

    // hide load more container in case the user is searching by term
    $(window).on('ajaxForm:request-sent',function(e,$form){
        // init
        var $plugin_container = $form.parents('.references-index-plugin');
        if ($plugin_container.length > 0) {
            $plugin_container.find('.ajax-items-container').addClass('loading');
        }
    });

    // hide load more container in case the user is searching by term
    $(window).on('ajaxForm:success',function(e,$form){
        // init
        var $plugin_container = $form.parents('.references-index-plugin');
        if ($plugin_container.length > 0) {
            $plugin_container.find('.load-more-container').hide();
            $plugin_container.find('.ajax-items-container').removeClass('loading');
        }
    });

});


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Project specific filter

*/

function initSpecialAjaxFilter() {
    // init
    let $plugin_container = $('.references-index-plugin');
    let $ajax_items_container = $plugin_container.find('.ajax-items-container');
    let $searchform_input = $('.references-index-plugin__search-input');
    let $filter = $('.special-filter');
    let $form = $('.special-filter__form');
    let $selects = $('select.special-filter__select');
    let $ajax_response_container = $('.special-filter-container');
    let ajax_filter_base_url = $filter.attr('data-ajax-filter-base-url');
    // find all selects and loop
    $selects.each(function(){
        // when a filter (select) is changed:
        $(this).change(function(e){
            // combined with categories?
            loadAjaxSpecial($form, $ajax_response_container, ajax_filter_base_url);
            // clear search field
            $searchform_input.val('');
            // add loading animation
            $ajax_items_container.addClass('loading');
        });
    });
}

function loadAjaxSpecial($form, $ajax_response_container, ajax_filter_base_url, append=false) {

    // init
    let postData = $form.serialize();
    let ajax_url = ajax_filter_base_url;
    let $plugin_container = $form.parents('.references-index-plugin');
    let $ajax_items_container = $plugin_container.find('.ajax-items-container');
    let $load_more_btn = $plugin_container.find('.ajax-load-items-special');

    // in case of a load more button, we don't want to append the post data
    if (append === false) {
        ajax_url += '&' + postData;
    }

    $.ajax({
        type: 'GET',
        url: ajax_url,
        contentType: 'application/json',
        success: function(data, textStatus, jqXHR) {

            // append or replace content?
            if (append === true) {
                $('.ajax-items-container').append(data.rendered_content);
            }else {
                $('.special-filter__inner').html(data.rendered_filters);
                $('.ajax-items-container').html(data.rendered_content);
                // re-init bootstrap select, but only if we do NOT append
                $(window).trigger('initBootstrapSelect');
                // re-init filter
                initSpecialAjaxFilter();
            }

            // trigger our custom event
            $(window).trigger('ajaxLoadItemsSpecial:success');

            // required for ajax button loader
            $(window).trigger('btnAjaxLoaderDone');

            // no softpage trigger, no honey
            $(window).trigger('initSoftpageTrigger');

            // handle "load more" visibility
            // dont show load more when only one page
            if (data.next_page_url == null || data.next_page_url === undefined){
                $plugin_container.find('.load-more-container').hide();
            }
            else{
                $plugin_container.find('.load-more-container').show();
                $load_more_btn.attr('href', data.next_page_url);
            }

            // remove loading animation
            $ajax_items_container.removeClass('loading');
        },
        error: function(xhr, status, error) {
            var err = "(" + xhr.responseText + ")";
            $(window).trigger('ajaxLoadItemsSpecial:error');
        }
    });

}

function initAjaxLoadItemsTriggerSpecial() {

    // find links and load items
    $('.ajax-load-items-special').each(function(){
        // init
        let $trigger = $(this);
        let initialized_attr = 'data-trigger-initialized';
        // check for initialized trigger
        let trigger_initialized = $trigger.attr(initialized_attr);

        // NOT initialized yet? keep going..
        if (typeof trigger_initialized === 'undefined') {
            // add event listener
            $trigger.on('click',function(e){
                // init
                let $trigger = $(this);
                let ajax_filter_base_url = $trigger.attr('href');
                let append = true;
                let $form = $('.special-filter__form');
                let $ajax_response_container = $('.special-filter-container');
                // let me handle this ;)
                e.preventDefault();
                loadAjaxSpecial($form, $ajax_response_container, ajax_filter_base_url, append);
            });
            // mark as initialized
            $trigger.attr(initialized_attr,'');
        }
    });

}



// WEBPACK FOOTER //
// ./static/js/modules/ajax-load-items.js